import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import './style/base.less'
import './assets/font/font.less'

import i18n from './assets/language/index.js'

import 'lib-flexible'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import Web3 from 'web3'
Vue.prototype.Web3 = Web3

import Vant from 'vant'
import { Toast } from 'vant'
import 'vant/lib/index.css'
Vue.prototype.$toast = Toast
Vue.use(Vant)

import '@/utils/filter' // base filter

// import Vconsole from 'vconsole'
// new Vconsole()

import FlowHeader from './components/FlowHeader.vue'
import FlowFooter from './components/FlowFooter.vue'
Vue.component('flow-header', FlowHeader)
Vue.component('flow-footer', FlowFooter)

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
